<template>
      <iframe :src="'https://radap.ir/Backend/map/store_map.html?id='+route.params.id" class="w-100 border-0" style="height:200px"></iframe>
</template>
<script setup>
import { useRoute } from 'vue-router';
let route = useRoute()
</script>